// extracted by mini-css-extract-plugin
export default {"progressHeader":"styles__progressHeader___vkrKA","footer":"styles__footer___3Do2O"};